import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { DISTRIBUTION_RULE_API } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

interface mutateProps {
  ruleId: string;
  communityId: string;
  data: FieldValues
}

const mutateUpdateRule = async ({ data, ruleId, communityId }: mutateProps) => {
  return await axiosAuth.put(
    `${DISTRIBUTION_RULE_API(communityId)}/${ruleId}/allocations`,
    data
  );
};

const useUpdateRuleMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateRule,
    ...queryParams,
  });

export default useUpdateRuleMutation;
